"use client";

import { getCookie, setCookie } from "cookies-next";
import { normalizeTwoPanelLayout } from "@/lib/panel-layout";
import { COOKIE_KEYS } from "./cookie-keys";
import {
  BROWSER_ACCESSIBLE_COOKIE_OPTIONS,
  COOKIE_MAX_AGE,
} from "./cookie-options";
import { resolveSharedCookieDomainFromHostname } from "./shared-cookie-domain";

const BROWSER_COOKIE_OPTIONS = {
  ...BROWSER_ACCESSIBLE_COOKIE_OPTIONS,
  maxAge: COOKIE_MAX_AGE.ONE_YEAR,
};

/**
 * サイドバーのレイアウト（パネルの幅の配列）をCookieに保存する
 * @param layout
 */
export const setSidebarLayoutCookie = (layout: number[]) => {
  const value = layout.join(",");
  setCookie(COOKIE_KEYS.SIDEBAR_LAYOUT, value, BROWSER_COOKIE_OPTIONS);
};

/**
 * サイドバーのレイアウト（パネルの幅の配列）をCookieから取得する
 * @param options
 * @returns
 */
export const getSidebarLayoutCookie = (): number[] | null => {
  const cookie = getCookie(COOKIE_KEYS.SIDEBAR_LAYOUT, BROWSER_COOKIE_OPTIONS);
  if (typeof cookie === "string") {
    try {
      const layout = cookie.split(",").map(Number);
      const normalizedLayout = normalizeTwoPanelLayout(layout);
      if (normalizedLayout) return normalizedLayout;
    } catch (e) {
      console.error("Failed to parse sidebar layout cookie", e);
      return null;
    }
  }
  return null;
};

/**
 * 最後に表示していたワークスペースIDをCookieに保存する。
 * 既存 Cookie と保存先を揃えるため、本番では Domain=app.amethy.st を維持します。
 */
export const setLastWorkspaceIdCookie = (workspaceId: string) => {
  const domain = resolveSharedCookieDomainFromHostname(
    window.location.hostname,
  );
  setCookie(COOKIE_KEYS.LAST_WORKSPACE_ID, workspaceId, {
    ...BROWSER_COOKIE_OPTIONS,
    ...(domain ? { domain } : {}),
  });
};

/** 受信トレイのレイアウト設定を設定（有効期限1年） */
export const setInboxLayoutCookie = (layout: number[]) => {
  return setCookie(COOKIE_KEYS.INBOX_LAYOUT, JSON.stringify(layout), {
    ...BROWSER_ACCESSIBLE_COOKIE_OPTIONS,
    maxAge: COOKIE_MAX_AGE.ONE_YEAR,
  });
};
